

$(document).ready(function() {
    var $window = $(window);

    function checkIfInView($elements) {
        var windowTop = $window.scrollTop();
        var windowBottom = windowTop + $window.height();

        $elements.each(function() {
            var $element = $(this);
            var elementTop = $element.offset().top;

            if (elementTop <= windowBottom) {
                $element.addClass('fadedup');
                $element.addClass('fadedIn');
            }
        });
    }

    /*
    // 초기 로드 시 한 번 확인
    checkIfInView($('.fadeup-slow'));
    checkIfInView($('.fadeup-fast'));
    checkIfInView($('.fadeup-fast2'));
    checkIfInView($('.fadein-right'));
    checkIfInView($('.fadein-left'));
*/

    // 스크롤 이벤트 처리
    $window.on('scroll', function() {
        checkIfInView($('.fadeup-slow'));
        checkIfInView($('.fadeup-fast'));
        checkIfInView($('.fadeup-fast2'));
        checkIfInView($('.fadein-right'));
    	checkIfInView($('.fadein-left'));
    });
});